import * as React from "react";
import { IExplorerProperties, IDataEntity } from "../../../models";
const styles = require('./CategorySelector.pcss');
// tslint:disable-next-line:variable-name
const FaAngleDown = require('react-icons/lib/fa/angle-down');
import { isNullOrUndefined, isNullOrWhitespace } from '../../../utils';

interface IProps {
    styles?: Object;
    filterData?: IDataEntity[];
    selectedIndex?: number;
    selectedText?: string;
    selectFn?: any;
}

interface IState {
    visible?: boolean;
    searchTerm?: string;
}

// const body = document.querySelector("body");

export class CategorySelector extends React.Component<IProps & IExplorerProperties, IState>{

    constructor(props) {
        super(props);
        this.state = { visible: false, searchTerm: null };
        this.onInputChange = this.onInputChange.bind(this);
        this.showDropdown = this.showDropdown.bind(this);
    }

    showDropdown() {
        let currentVisibility = this.state.visible;
        this.setState({ visible: !currentVisibility });
    }

    hideDropdown() {
        this.setState({ visible: false });
    }

    onInputChange(event) {
        let searchTerm = event.target.value;
        this.setState({ searchTerm });
    }

    onDropdownInputChange(item, index) {
        let { selectFn } = this.props;
        selectFn({ index: index, identifier: item.value, text: item.text });
        this.hideDropdown();
    }

    render() {
        let visibility = this.state.visible ? styles.active : '';
        let internalClasses = {
            dropdown: `${styles.dropdown} ${visibility}`,
            arrow: `${styles.arrow} ${visibility}`
        };
        let { filterData, selectedIndex, selectedText } = this.props;
        let selectorText;
        let { searchTerm } = this.state;
        if (isNullOrUndefined(selectedIndex)) {
            if (selectedText === "") {
                selectorText = "Select an item";
            } else {
                selectorText = selectedText;
            }
        } else {
            selectorText = filterData[selectedIndex].text;
        }

        let isBlankSearch = isNullOrWhitespace(searchTerm);
        filterData = isBlankSearch ? filterData : filterData.filter((item) => (
            item.text.toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0
        ));

        return (
            <div className={styles.filterWrapper} >
                <div className={styles.filterButton} onClick={this.showDropdown}>
                    {selectorText} <div><FaAngleDown /></div>
                </div>

                <section className={internalClasses.dropdown}>
                    <div className={styles.options}>
                        <ul>
                            <li><input type='text' onChange={this.onInputChange} value={searchTerm || ""} /></li>
                            {filterData.map((item, index) => (
                                <li className={"performance-dropdown-item"} key={`${item.value}-${index}`} onClick={() => this.onDropdownInputChange(item, index)} >{item.text}</li>
                            ))}
                        </ul>
                    </div>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/client/components/PagePerformance/CategorySelector/CategorySelector.tsx